<template>
  <div class="login">
    <vue-particles color="#dedede"></vue-particles>
    <el-card
      class="box-card login-form"
      style="
        width: 360px;
        height: 200px;
        position: absolute;
        left: 50%;
        top: 40%;
        margin-left: -180px;
        margin-top: -100px;
        box-shadow: 0 0 8px #eeeeee;
      "
    >
      <el-form
        :model="form"
        :rules="rules"
        label-width="70px"
        ref="form"
        class="demo-ruleForm"
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="密码框" prop="password">
          <el-input
            type="password"
            v-model="form.password"
            autocomplete="off"
            @keyup.enter.native="keyupEnter('form')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit('form')"
            >登录<i class="el-icon-loading" v-show="saveing"></i
          ></el-button>
          <el-button @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Utility from '@/components/mixin.js'
import axios from 'axios'
export default {
  mixins: [Utility],
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        password: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
      },
      saveing: false
    }
  },
  methods: {
    //输入框回车点击事件
    keyupEnter(form) {
      this.onSubmit(form)
    },
    onloading(val) {
      if (val) {
        this.$set(this, 'saveing', true)
      } else {
        this.$set(this, 'saveing', false)
      }
    },
    onSubmit(form) {
      this.onloading(true)
      const that = this
      this.$refs[form].validate((valid) => {
        if (valid) {
          // that.$router.push('/')
          // localStorage.setItem('Flag', true)
          // localStorage.setItem('token', "res.data.token")
          // localStorage.setItem('entid', "res.data.entid")
          axios
            .post('/mananger/task/manager', that.form)
            .then((response) => {
              let res = response.data
              console.log(res)
              if (res.code === 1) {
                that.$store.dispatch('userLogin', true)
                localStorage.setItem('Flag', true)
                localStorage.setItem('token', res.data.token)
                localStorage.setItem('entname', this.form.username)
                that.$router.push('/admin')
                setTimeout(() => {
                  location.reload() // 强制刷新
                }, 500)
              } else {
                this.err_process(
                  res.code,
                  '登录异常:[' + res.code + ']' + res.message
                )
              }
              that.onloading(false)
            })
            .catch((err) => {
              console.error(err)
              that.onloading(false)
              this.err_process('AAAA', '登录异常:[AAAA]' + err)
            })
          return false
        } else {
          //console.log('error submit!!');
          return false
        }
      })
    },
    resetForm(form) {
      this.$refs[form].resetFields()
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.username = ''
      this.form.password = ''
    }
  }
}
</script>

<style scoped>
#particles-js {
  width: 100%;
  height: calc(100%);
  position: absolute;
  background-color: #1e9fff;
}
</style>
